import React from 'react';
// import PropTypes from 'prop-types';
import Title from '../partials/Title';
import NotebookCards from '../partials/NotebookCards';

import * as AppPropTypes from '../../lib/PropTypes';

import styles from '../../../styles/pages/list.scss';

const propTypes = {
    page: AppPropTypes.page.isRequired,
};

const ListPage = ({ page }) => (
    <div className={styles.container}>
        <Title
            className={styles.title}
            seed={`title-${page.id}`}
            text={page.title}
            format="normal"
            borderPosition="none"
        />
        <div className={styles.notebookContainer}>
            <NotebookCards
                className={styles.blocks}
                items={page.items}
                pagination={page.pagination}
                tags={page.tags}
            />
        </div>
    </div>
);

ListPage.propTypes = propTypes;

export default ListPage;
